// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8dc82175fe100aa7c71d","655":"c9217834d9f1dd9f6860"}[chunkId] + ".js";
};